<template>
    <div class="panel">
        <div class="title-banner">
            <span class="title" v-if="title_show">购买须知</span>
<!--            <span class="help-icon"><van-icon name="question-o" /></span>-->
        </div>
        <div v-html="info.notice"></div>
    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    export default {
        name: "ProductPartFour",
        props:{
            product_id:{
                type:String,
                default:'',
                required:false,
            }
        },
        data(){
            return {
                info:{},
                title_show:false
            }
        },
        methods:{
            ...mapActions([
                'GetProductPublishedNotice',
            ]),
            loadData(){
                let product_id=this.product_id;
                this.GetProductPublishedNotice({product_id}).then(res=>{
                    this.info = res;
                    this.title_show=!!this.info.notice;
                    console.log('--------- 购买须知 --------')
                    console.log(this.info.notice);
                })
            }
        },
        mounted() {
            this.loadData();
        }
    }
</script>


<style lang="scss" scoped>
    .panel{
        background-color: #FFFFFF;
        margin-top: 5px;
    }
    .title-banner{
        padding: 5px;
        text-align: left;
        .title{
            font-size: 14px;
            color: #333333;
            font-weight: bold;
        }
        .help-icon{
            font-size: 18px;
            color: #666666;
            float: right;
        }
    }
</style>
